import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import { LISTING_OCCUPANT_TYPE_VACANT } from 'common/listingConstants';
import { formatPhoneNumber } from 'common/formatters';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import SrFlex from 'client/components/SrFlex';
import SrLink from 'client/components/SrLink/SrLink';

import './SrPartnerListingOccupancyInfo.less';

const SrPartnerListingOccupancyInfo = ({ listing, partner }) => {
  const { occupantType, vacantDate, occupantName, occupantPhone, occupantEmail } = listing;

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const isVacant = occupantType === LISTING_OCCUPANT_TYPE_VACANT;

  return (
    <SrBox
      backgroundColor="white"
      borderRadius={isSmallScreen ? '14px' : '24px'}
      boxShadow="0px 5px 21px rgba(25, 51, 64, 0.05)"
      padding="20px 0px"
    >
      <SrFlex padding={isVacant ? '0 20px' : '0 20px 23px'}>
        <SrBox marginTop="5px" marginRight="9px">
          <SrIcon className={isVacant ? 'checkmark-rounded-green' : 'person-filled-orange'} />
        </SrBox>
        <SrBox>
          <SrFlex wrap="wrap">
            <SrText
              font="greycliff"
              fontSize="21px"
              weight="800"
              lineHeight="26px"
              color={isVacant ? 'green' : 'orange300'}
              display="block"
            >
              {isVacant ? 'Vacant' : `${occupantType} Occupied`}
              {isVacant && vacantDate && ` (since ${moment(vacantDate).format('MMMM Do')})`}
            </SrText>
          </SrFlex>
        </SrBox>
      </SrFlex>
      {(occupantName || occupantPhone || occupantEmail) && (
        <SrBox margin="0 20px 24px">
          <SrFlex justify="between">
            <SrText
              color="blueGreycliff"
              opacity="0.5"
              font="greycliff"
              fontSize="16px"
              weight="800"
              lineHeight="24px"
            >
              {occupantType && occupantType !== LISTING_OCCUPANT_TYPE_VACANT
                ? 'Current Occupant'
                : 'Previous Tenant'}
            </SrText>
            <SrLink to={`/partner/${partner.slug}/listing/${listing.id}/edit/showing-access`}>
              <SrText font="greycliff" weight="bold" color="blue300">
                Edit
              </SrText>
            </SrLink>
          </SrFlex>
          {occupantName && (
            <SrText
              color="blueGreycliff"
              font="greycliff"
              fontSize="21px"
              weight="800"
              lineHeight="30px"
              display="block"
            >
              {occupantName.split(';')[0]}
            </SrText>
          )}
          {occupantPhone && (
            <SrText
              color="blueGreycliff"
              font="greycliff"
              fontSize="21px"
              weight="800"
              lineHeight="30px"
              display="block"
            >
              {formatPhoneNumber(occupantPhone)}
            </SrText>
          )}
          {occupantEmail && (
            <SrText
              color="blueGreycliff"
              font="greycliff"
              fontSize="21px"
              weight="800"
              lineHeight="30px"
              display="block"
            >
              {occupantEmail}
            </SrText>
          )}
        </SrBox>
      )}
    </SrBox>
  );
};

SrPartnerListingOccupancyInfo.propTypes = {
  listing: PropTypes.object.isRequired,
  partner: PropTypes.object.isRequired,
};

SrPartnerListingOccupancyInfo.displayName = 'SrPartnerListingOccupancyInfo';

export default SrPartnerListingOccupancyInfo;
